(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq2-item");
  faqItems.forEach(item => {
    item.addEventListener("click", () => {
      item.classList.toggle("open");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-info-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".infoTabs-tab");
  const panes = document.querySelectorAll(".infoTabs-pane");
  const faqSection = document.getElementById("faq2-section");
  const returnsSection = document.getElementById("returns-section");
  const contactSection = document.getElementById("custom-c-section");
  const termsSection = document.getElementById("terms-section");
  const privacySection = document.getElementById("privacy-section");


  tabs.forEach(tab => {
  tab.addEventListener("click", () => {
    const target = tab.getAttribute("data-target");

    tabs.forEach(t => t.classList.remove("active"));
    panes.forEach(p => p.style.display = "none");

    if (faqSection) faqSection.style.display = "none";
    if (returnsSection) returnsSection.style.display = "none";
    if (contactSection) contactSection.style.display = "none";
    if (termsSection) termsSection.style.display = "none";
    if (contactSection) contactSection.style.display = "none";
    if (privacySection) privacySection.style.display = "none";

    tab.classList.add("active");

    if (target === "faqs") {
      if (faqSection) faqSection.style.display = "block";
    }
    else if (target === "returns") {
      if (returnsSection ) returnsSection .style.display = "block";
    }
    else if (target === "contact") {
      if (contactSection ) contactSection.style.display = "block";
    }
    else if (target === "terms") {
      if (termsSection) termsSection.style.display = "block";
    }
    else if (target === "privacy") {
      if (privacySection) privacySection.style.display = "block";
    }
    else {
      const activePane = document.getElementById(target);
      if (activePane) activePane.style.display = "block";
    }
  });
});
  if (tabs.length > 0) tabs[0].click();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
